<template>

    <v-card>
        <v-card-title>Forgot Password</v-card-title>

        <v-divider></v-divider>

        <v-card-text class="card-area">

            <template v-if="lockedOut">
                <span class="contact-sys">Please contact your system administrator.</span>
            </template>

            <template v-if="!lockedOut">
                <v-window v-model="step">

                    <v-window-item>
                        <v-text-field class="mt-6" v-model="username" color="#c42111" label="Username" prepend-icon="mdi-account" @keyup.enter.native="checkUsername">
                            <template v-slot:append-outer>
                                <v-btn color="#c42111" :disabled="!username" @click="checkUsername">
                                    <span v-if="!checkingUsername">GO</span>
                                    <v-icon v-if="checkingUsername">fas fa-spinner fa-spin</v-icon>
                                </v-btn>
                            </template>
                        </v-text-field>
                        <span class="not-found-text" v-if="showNotFound">
                            Username not found. <b>{{attemptsRemaining}}</b> attempts remaining.
                        </span>
                    </v-window-item>

                    <v-window-item>
                        <span class="choose-verify-text pt-3">
                            Please choose which account verification method you prefer to use.
                        </span>
                        <div class="verification-method-container">
                            <v-btn class="mr-2 mt-3" color="#c42111" @click="startVerifyEmail">Email</v-btn>
                            <v-btn class="ml-2 mt-3" color="#c42111" @click="startVerifySMS">SMS</v-btn>
                        </div>
                    </v-window-item>

                    <v-window-item>
                        <span class="verify-start-text">
                            <div style="width: 100%; text-align: center; position: relative;">

                                <span class="sent-code-message">Please enter the <b>{{ `${verifyType == 'sms' ? 'SMS' : 'EMAIL'}` }}</b> verification code</span>

                                <v-text-field class="sms-code-box pt-8" color="#c42111" outlined maxlength=1 id="sms-verify-code-box-1" @keyup="moveOnMax($event, 'sms-verify-code-box-2')" v-model="digit1" :disabled="resending" />
                                <v-text-field class="sms-code-box" color="#c42111" outlined maxlength=1 id="sms-verify-code-box-2" @keyup="moveOnMax($event, 'sms-verify-code-box-3')" v-model="digit2" :disabled="resending" />
                                <v-text-field class="sms-code-box" color="#c42111" outlined maxlength=1 id="sms-verify-code-box-3" @keyup="moveOnMax($event, 'sms-verify-code-box-4')" v-model="digit3" :disabled="resending" />
                                <v-text-field class="sms-code-box" color="#c42111" outlined maxlength=1 id="sms-verify-code-box-4" @keyup="moveOnMax($event, 'sms-verify-code-box-5')" v-model="digit4" :disabled="resending" />
                                <v-text-field class="sms-code-box" color="#c42111" outlined maxlength=1 id="sms-verify-code-box-5" @keyup="moveOnMax($event, 'sms-verify-code-box-6')" v-model="digit5" :disabled="resending" />
                                <v-text-field class="sms-code-box" color="#c42111" outlined maxlength=1 id="sms-verify-code-box-6" @keyup="checkIfComplete()" v-model="digit6" :disabled="resending" />
                                <v-btn class="ml-5 mb-6 sms-verify-code-button" color="#c42111" @click="verifyCode" :disabled="code.length != 6">
                                    <v-icon class="loader" v-if="verifyingCode">fas fa-spinner fa-spin</v-icon>
                                    <span v-if="!verifyingCode">verify code</span>
                                </v-btn>

                                <div class="verify-failed" v-if="verifyFailed">
                                    <div style="display: inline-block"><v-icon class="mr-2" color="#ff5252" small>mdi-alert</v-icon></div>
                                    <div style="display: inline-block"><span>Invalid Code</span></div>
                                </div>
                            </div>
                        </span>
                    </v-window-item>

                    <v-window-item>
                        <v-text-field class="pt-6 new-password-input" label="Password" :type="showPassword ? 'text' : 'password'" color="#c42111" v-model="newPassword" @input="debounceCheckPasswordComplexity" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" @click:append="showPassword = !showPassword" :rules="[validation.pwStrength(newPassword, passwordPass)]">
                            <template v-slot:append-outer>
                                <v-icon class="checking-password" v-if="checkingPassword">fas fa-spinner fa-spin</v-icon>
                                <span class="password-strength" :class="passwordStrength" v-if="!checkingPassword && passwordStrength" v-html="passwordStrength + ''"></span>
                                <v-btn color="#c42111" @click="resetPassword" :disabled="!passwordPass">Set</v-btn>
                            </template>
                        </v-text-field>
                    </v-window-item>

                    <v-window-item>
                        <span class="finished-text">Your new password has been set.</span>
                    </v-window-item>

                </v-window>
            </template>

        </v-card-text>

        <v-divider />

        <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn text @click="$emit('cancel')">{{ `${this.attemptsRemaining > 0 && this.step != 4 ? 'Cancel' : 'Close'}` }}</v-btn>
        </v-card-actions>
    </v-card>

</template>

<script>
import _ from 'lodash';
export default {
    name: 'ForgotPassword',
    props: ['existingUsername'],
    components: {
    },
    data: () => ({
        username: '',
        checkingUsername: false,
        showNotFound: false,
        attemptsRemaining: 5,
        lockedOut: false,
        step: 0,
        sms: null,
        email: null,
        userData: null,
        verifyType: null,
        verifySuccessData: null,

        newPassword: '',
        showPassword: false,
        checkingPassword: false,
        passwordStrength: '',
        passwordPass: false,


        digit1: '',
        digit2: '',
        digit3: '',
        digit4: '',
        digit5: '',
        digit6: '',
        autoVerifyUsed: false,
        verifyingCode: false,
        verifySuccess: false,
        verifyFailed: false,
        resending: false,
        clockTickIntervalFunc: null,
        expTimerSec: 600,

        validation: {
            pwStrength: (value, passwordPass) => ((!value || passwordPass) || "Password doesn't meet the complexity requirements"),
        }
    }),

    computed: {
        code: function() {
            return `${this.digit1}${this.digit2}${this.digit3}${this.digit4}${this.digit5}${this.digit6}`;
        },

        expTimerPretty: function() {
            if(this.expTimerSec == null) {
                return null;
            }
            return (TELSA.moment("1900-01-01 00:00:00").add(this.expTimerSec, 'seconds').format("mm:ss"));
        },
    },

    methods: {    
        checkUsername: function() {
            console.log('check usernaem!');
            if(this.checkingUsername) {
                return;
            }
            let route = (TELSA.apiHost + "auth/checkusername");
            this.checkingUsername = true;
            return this.$http.post(route, {args: {username: this.username, check_username_secret: 'ndzpDb92*BXXJ*BC'}}).then(response => {
                let result = response.body;
                console.log(result);
                if(!result) {
                    if(this.attemptsRemaining > 1) {
                        this.showNotFound = true;
                    }
                    else {
                        this.lockedOut = true;
                    }
                    this.decrementAttempt();
                }
                else {
                    this.sms = result.sms;
                    this.email = result.email;
                    this.userData = result.data;
                    if(this.sms && this.email) {
                        this.step = 1;
                    }
                    else if(this.sms && !this.email) {
                        this.step = 2;
                        this.startVerifySMS();
                    }
                    else if(!this.sms && this.email) {
                        this.step = 2;
                        this.startVerifyEmail();
                    }
                    else if(!this.sms && !this.email) {
                        this.lockedOut = true;
                    }
                }
                this.checkingUsername = false;
            });
        },

        decrementAttempt: function() {
            this.attemptsRemaining = this.attemptsRemaining - 1;
            localStorage.setItem('check_username_attempts_remaining', this.attemptsRemaining);
        },

        startVerifySMS: function() {
            this.verifyType = 'sms';
            let route = 'https://page.telsasoft.com/api/v1/forgotpasswordsms/start';
            return this.$http.post(route, {data: this.userData}).then(response => {
                let result = response.body;
                if(result != 'success') {
                    this.lockedOut = true;
                }
                else {
                    this.step = 2;
                }
            });
        },

        startVerifyEmail: function() {
            this.verifyType = 'email';
            let route = 'https://page.telsasoft.com/api/v1/forgotpasswordemail/start';
            return this.$http.post(route, {data: this.userData}).then(response => {
                let result = response.body;
                if(result != 'success') {
                    this.lockedOut = true;
                }
                else {
                    this.step = 2;
                }
            });
        },

        verifyCode: function() {
            let route = '';
            this.verifyingCode = true;
            if(this.verifyType == 'sms') {
                route = 'https://page.telsasoft.com/api/v1/forgotpasswordsms/verify';
                return this.$http.post(route, {data: this.userData, code: this.code}).then(response => {
                    let result = response.body;
                    if(!result.success) {
                        this.verifyFailed = true;
                    }
                    else {
                        this.verifySuccessData = result.success;
                        this.step = 3;
                    }
                    this.verifyingCode = false;
                });
            }
            else if(this.verifyType == 'email') {
                route = 'https://page.telsasoft.com/api/v1/forgotpasswordemail/verify';
                return this.$http.post(route, {data: this.userData, code: this.code}).then(response => {
                    let result = response.body;
                    if(!result.success) {
                        this.verifyFailed = true;
                    }
                    else {
                        this.verifySuccessData = result.success;
                        this.step = 3;
                    }
                    this.verifyingCode = false;
                });
            }
        },

        resetPassword: function() {
            let route = (TELSA.apiHost + "auth/resetpassword");
            this.checkingUsername = true;
            return this.$http.post(route, {args: {data: this.verifySuccessData, check_username_secret: 'ndzpDb92*BXXJ*BC', password: this.newPassword}}).then(response => {
                let result = response.body;
                this.step = 4;
            });
        },

        moveOnMax: function(event, nextFieldID) {
            let field = event.srcElement;
            if(event.key == 'Tab' || event.key == 'Shift') {
                return;
            }
            if (field.value.length == 1) {
                document.getElementById(nextFieldID).focus();
            }
        },

        checkIfComplete: function() {
            if(this.code.length == 6 && !this.autoVerifyUsed) {
                this.autoVerifyUsed = true;
                this.verifyCode();
            }
        },

        setupTimer: function() {
            let self = this;
            clearInterval(this.clockTickIntervalFunc);
            this.clockTickIntervalFunc = setInterval(function() {
                if(self.expTimerSec > 0) {
                    self.expTimerSec = (self.expTimerSec - 1);
                }
                else {
                    self.$emit('cancel');
                }
            }, 1000);
        },

        debounceCheckPasswordComplexity: _.debounce(function() {
            this.checkPasswordComplexity();
        }, 500),

        checkPasswordComplexity: function() {
            let route = (TELSA.apiHost + "auth/passwordcomplexity");
            this.checkingPassword = true;
            this.passwordStrength = "checking...";
            return this.$http.post(route, {args: {password: this.newPassword}}).then(response => {
                let result = response.body;
                console.log(result);
                this.checkingPassword = false;
                this.passwordStrength = result.strength;
                this.passwordPass = result.pass;
            });
        },
    },

    created() {
    },

    mounted() {
        this.username = this.$props.existingUsername || "";
        this.attemptsRemaining = localStorage.getItem('check_username_attempts_remaining') || this.attemptsRemaining;
        this.lockedOut = this.attemptsRemaining < 1;
    },

    destroyed() {
        clearInterval(this.clockTickIntervalFunc);
    },
};
</script>

<style scoped>

    .card-area {
        display: block;
        position: relative;
        height: 106px;
    }

    .not-found-text {
        color: #ff5252;
        font-size: 15px;
        display: block;
        position: absolute;
        bottom: -5px;
        left: 32px;
    }

    .contact-sys {
        display: block;
        position: absolute;
        font-size: 18px;
        text-align: center;
        margin-top: 40px;
        margin-left: calc((550px - 24px - 340px) / 2);
    }

    .choose-verify-text {
        display: block;
        text-align: center;
        font-size: 14px;
    }

    .verification-method-container {
        display: block;
        text-align: center;
        width: 100%;
    }

    .sent-code-message {
        display: block;
        position: absolute;
        width: 100%;
        margin-top: 5px;
    }

    .sms-code-box {
        display: inline-block;
        width: 1.5em;
        margin-right:0.28em;
        font-size: 28px;
        height: 65px;
    }

    .sms-verify-code-button {
        display: inline-block;
    }

    .verify-failed {
        font-size: 15px;
        display: block;
        position: absolute;
        right: 65px;
        bottom: 0px;
    }
    .verify-failed span {
        color: #ff5252;
        vertical-align: middle;
    }







    .new-password-text {
        display: block;
        text-align: center;
        font-size: 14px;
    }
    .new-password-text .pw {
        display: block;
        text-align: center;
        font-size: 18px;
        font-weight: bold;
    }


    .new-password-input {

    }

    .checking-password {
        width: 60px;
    }
    .password-strength {
        color: #ffffff;
        margin-top: 0.5em;
        width: 60px;
    }
    .password-strength.bad {
        color: red;
    }
    .password-strength.weak {
        color: orange;
    }
    .password-strength.good {
        color: teal;
    }
    .password-strength.strong {
        color: green;
    }

    .finished-text {
        font-size: 18px;
        padding-top: 35px;
        text-align: center;
        display: block;
    }

</style>

